<template>
    <div>
        <section>
            <div v-if="$route.path == '/SendGoods/SendGoodsForHX'">
                <el-form :inline="true" class="toolbar" style="padding-bottom: 0px">
                    <el-form-item label="销售下单号:" label-width="90px">
                        <el-input v-model="query.OrderCode" class="formlength"></el-input>
                    </el-form-item>
                    <el-form-item label="发货通知单号:" label-width="100px">
                        <el-input v-model="query.SendCode" class="formlength"></el-input>
                    </el-form-item>
                    <el-form-item label="代理商:" label-width="80px">
                        <el-input v-model="query.AgentName" class="formlength"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人:" label-width="80px">
                        <el-input v-model="query.c_name" class="formlength"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="所属区域:" label-width="80px">
                                <el-input v-model="query.AreaName" class="formlength"></el-input>
                            </el-form-item>-->
                    <el-form-item label="发货通知单状态:" label-width="120px">
                        <el-select placeholder="-请选择-" class="formlength" v-model="query.Status">
                            <el-option v-for="option in queryType" :value="option.TypeValue" :label="option.TypeName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发货状态:" label-width="80px">
                        <el-select placeholder="-请选择-" class="formlength" v-model="query.DeliveryStatus">
                            <el-option v-for="option in queryDelivery" :value="option.TypeValue" :label="option.TypeName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" @click="onQuerySubmit" style="margin-bottom:10px" icon="search">查询</el-button>
                    <el-button type="primary" @click="onQueryClean" style="margin-bottom:10px" icon="delete2">重置</el-button>
                </el-form>
                <div>
                    <el-table :data="lists" v-loading="loading2" element-loading-text="拼命加载中" border style="width: 100%;" @selection-change="selsChange" router>
                        <el-table-column label="发货通知单号" prop="SendCode"></el-table-column>
                        <el-table-column label="销售下单号" prop="OrderCode"></el-table-column>
                        <el-table-column label="代理商" prop="AgentName"></el-table-column>
                        <el-table-column label="主联系人" prop="C_Name"></el-table-column>
                        <el-table-column label="所属区域" prop="AreaName"></el-table-column>
                        <el-table-column label="财务审核时间" prop="SendTime"></el-table-column>
                        <el-table-column label="所属业务经理" prop="SaleEmployeeName"></el-table-column>
                        <el-table-column label="出库次数" prop="StockOutNum"></el-table-column>
                        <el-table-column label="发货通知单状态" prop="StatusName"></el-table-column>
                        <el-table-column label="发货状态" prop="DeliveryStatusName"></el-table-column>
                        <el-table-column label="操作" width="280px">
                            <template scope="scope">
                                <el-button size="small" @click="handleView(scope.$index, scope.row)" icon="view" type="success">查看</el-button>
                                <el-button size="small" @click="NewStockOut(scope.$index, scope.row)" icon="edit" :disabled="(scope.row.btnVue&512)<=0" type="primary">生成出库单</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-col :span="24" class='btm-action'>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
                    </el-pagination>
                </el-col>
            </div>
            <div v-else>
                <router-view></router-view>
            </div>
        </section>

        <!--查看-->
        <el-dialog title="销售下单审核" v-model="SaleCheckView" size="tiny">
            <el-form style="margin:20px;width:60%;min-width:100%" label-width="100px">

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="SaleCheckView=false">通 过</el-button>
                <el-button type="primary" @click="SaleCheckView=false">驳 回</el-button>
                <el-button @click="SaleCheckView=false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<style lang="scss">
.btm-action {
    display: flex;
    justify-content: center;
    margin: 5px 0px;
}

.formlength {
    width: 160px;
}
</style>

<script>
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { GetSendGoodsForBus, ERP_InvalidSendGoods, ERP_SendGoodsDel, GetOtherSendGoodsByPage } from '@api/sendGoodsApi';
import NProgress from 'nprogress';

export default {
    data: function () {
        return {
            Session: util.getSessin(),
            queryType: this.$store.state.OutboundStatus,
            queryDelivery: [
                { "TypeName": "-请选择-", "TypeValue": "-1" },
                { "TypeName": "未发货", "TypeValue": "0" },
                { "TypeName": "部分发货", "TypeValue": "1" },
                { "TypeName": "全部发货", "TypeValue": "2" }
            ],
            loading2: false,
            lists: [{ "Id": "346567788" }],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            sels: [],//列表选中列
            SaleCheckView: false,
            pageSizes: [10, 20, 50],
            query: this.getQueryData()
        }
    },
    methods: {
        getQueryData() {
            return cloneDeep({
                OrderCode: "",
                SendCode: "",
                AgentName: "",
                AreaName: "",
                Status: "",
                c_name: "",
                DeliveryStatus: "",
                BusUser: ""
            });
        },
        //初始化加载页面
        List: function () {
            this.lists = [];
            this.loading2 = true;//拼命加载中显示
            var para = this.getParams();

            GetOtherSendGoodsByPage(para).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode != 0) {
                    alert(res.data.StateMsg);
                    return;
                }
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                for (var i = 0; i < Data.length; i++) {
                    Data[i].AreaName = Data[i].AreaName.split("市")[0] + '市'
                    if (Data[i].AreaName == "北京北京市") {
                        Data[i].AreaName = "北京市"
                    }
                    if (Data[i].AreaName == "重庆重庆市") {
                        Data[i].AreaName = "重庆市"
                    }
                    if (Data[i].AreaName == "上海上海市") {
                        Data[i].AreaName = "上海市"
                    }
                    if (Data[i].AreaName == "天津天津市") {
                        Data[i].AreaName = "天津市"
                    }
                }
                this.outTips(StateCode, StateMsg, Data, Cnt);
            });
        },
        //通用输入参数
        getParams: function () {
            var para = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
           for (let item in this.query) {
                let value = this.query[item];
                if (value != '') {
                    para[item] = value;
                }
            }
            return para
        },
        //通用提示信息
        outTips: function (StateCode, StateMsg, Data, Cnt) {
            if (StateCode !== 0 && StateCode !== 99) {
                this.$notify({
                    title: '错误',
                    message: StateMsg,
                    type: 'error'
                });
            } else {
                this.totalSize = Cnt;
                this.loading2 = false;//拼命加载中隐藏
                this.lists = Data;
            }
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //查询
        onQuerySubmit: function () {
            this.pageIndex = 1;
            this.lists = [];
            this.loading2 = true;//拼命加载中显示
            var para = this.getParams()
            GetOtherSendGoodsByPage(para).then(res => {
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                this.outTips(StateCode, StateMsg, Data, Cnt)
            });
        },//查询功能
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.List();
        },
        //查询单条
        handleView: function (index, row) {
            util.redirect(this, '/SendGoods/SendGoodsForHXView?Id=' + row.SendId, true);
        },
        //修改
        EditHandle: function (index, row) {
            util.redirect(this, '/Order/SaleOrder/CreateSkipOrder?Id=' + row.SendId + "&update=true", false);
        },//删除
        DelHandle: function (index, row) {
            this.$confirm('确认删除该发货通知单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                NProgress.start();
                let para = { Ids: row.SendId };
                ERP_SendGoodsDel(para).then((response) => {
                    NProgress.done();
                    if (response.data.StateCode !== 0) {
                        this.$notify({
                            title: '错误',
                            message: response.data.StateMsg,
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: '成功',
                            message: '删除成功',
                            type: 'success'
                        });
                        this.List();
                    }
                });
            }).catch(() => {

            });
        },//禁用
        EnableHandle: function (index, row) {
            this.$confirm('确认作废该发货通知单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                NProgress.start();
                let para = {
                    SendId: row.SendId,
                    Sid: this.Session[0],
                    Session: this.Session[1]
                };
                ERP_InvalidSendGoods(para).then((response) => {
                    NProgress.done();
                    if (response.data.StateCode !== 0) {
                        this.$notify({
                            title: '错误',
                            message: response.data.StateMsg,
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: '成功',
                            message: '作废成功',
                            type: 'success'
                        });
                        this.List();
                    }
                });
            }).catch(() => {

            });
        },
        //生成出库
        NewStockOut(index, row) {
            util.redirect(this, '/StockOut/AddStockOutHX?Id=' + row.SendId, true);
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.List();
        },
        //编辑功能
        onQueryClean: function () {
            this.query = this.getQueryData();
            this.List();
        },
        created: function () {
            this.List();
        }
    },
    watch: {
        '$route'(to, from) {
            if (this.$route.path == '/SendGoods/SendGoodsForHX') {
                this.List();
            }
        }
    },
    created() {
        this.List();
    }
};
</script>




// WEBPACK FOOTER //
// SendGoodsForHX.vue?25c715f0